"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEASON_IDS = void 0;
exports.SEASON_IDS = {
    BUNDESLIGA: {
        SAISON_23_24: '44562567-09d8-4e99-9fad-200e972efba1',
        SAISON_24_25: 'e4b4bf75-436d-4b9b-838f-04c6e72dd5f6'
    },
    DFB_POKAL: {
        SAISON_23_24: 'eb6e9e30-eb13-4e6e-bb56-fb1d0cef7333',
        SAISON_24_25: '1a50e1d1-fe5b-4507-b5cd-af19dd162601'
    }
};
